import { render, staticRenderFns } from "./base-client-table.vue?vue&type=template&id=5808f13e&scoped=true&"
import script from "./base-client-table.vue?vue&type=script&lang=js&"
export * from "./base-client-table.vue?vue&type=script&lang=js&"
import style0 from "./base-client-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./base-client-table.vue?vue&type=style&index=1&id=5808f13e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808f13e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
